// All 13 logical steps
export const STEPS = [
  { id: 1,  title: 'Student'  },
  { id: 2,  title: 'School'   },
  { id: 3,  title: 'Board'    },
  { id: 4,  title: 'Course 1' },
  { id: 5,  title: 'Course 2' },
  { id: 6,  title: 'Course 3' },
  { id: 7,  title: 'Course 4' },
  { id: 8,  title: 'Course 5' },
  { id: 9,  title: 'Course 6' },
  { id: 10, title: 'Course 7' },
  { id: 11, title: 'Course 8' },
  { id: 12, title: 'Course 9' },
  { id: 13, title: 'Credits'  },
]

// Steps 4-12 are course steps, grouped under the "Courses" parent node
export const COURSE_STEP_IDS = new Set([4, 5, 6, 7, 8, 9, 10, 11, 12])

// Top-level indicator nodes (5 nodes)
export const TOP_STEPS = [
  { id: 1,         title: 'Student' },
  { id: 2,         title: 'School'  },
  { id: 3,         title: 'Board'   },
  { id: 'courses', title: 'Courses', group: { stepIds: [4, 5, 6, 7, 8, 9, 10, 11, 12], jumpTo: 4 } },
  { id: 13,        title: 'Credits' },
]

// Sub-row course nodes - always visible beneath the top row
export const COURSE_SUB_STEPS = [
  { id: 4,  courseNum: 1 },
  { id: 5,  courseNum: 2 },
  { id: 6,  courseNum: 3 },
  { id: 7,  courseNum: 4 },
  { id: 8,  courseNum: 5 },
  { id: 9,  courseNum: 6 },
  { id: 10, courseNum: 7 },
  { id: 11, courseNum: 8 },
  { id: 12, courseNum: 9 },
]

// Course metadata - used for DRY rendering in Page.jsx
export const COURSE_STEPS = [
  { stepId: 4,  courseNum: 1, semLabel: 'Semester 1' },
  { stepId: 5,  courseNum: 2, semLabel: 'Semester 1' },
  { stepId: 6,  courseNum: 3, semLabel: 'Semester 1' },
  { stepId: 7,  courseNum: 4, semLabel: 'Semester 1' },
  { stepId: 8,  courseNum: 5, semLabel: 'Semester 2' },
  { stepId: 9,  courseNum: 6, semLabel: 'Semester 2' },
  { stepId: 10, courseNum: 7, semLabel: 'Semester 2' },
  { stepId: 11, courseNum: 8, semLabel: 'Semester 2' },
  { stepId: 12, courseNum: 9, semLabel: 'Semester 2' },
]

// Key fields required for step-completion detection
export const STEP_FIELDS = {
  1:  ['studentName', 'oen', 'grade', 'semester'],
  2:  ['schoolName'],
  3:  ['boardName'],
  4:  ['course1Title', 'course1FinalPercentageMark'],
  5:  ['course2Title', 'course2FinalPercentageMark'],
  6:  ['course3Title', 'course3FinalPercentageMark'],
  7:  ['course4Title', 'course4FinalPercentageMark'],
  8:  ['course5Title', 'course5FinalPercentageMark'],
  9:  ['course6Title', 'course6FinalPercentageMark'],
  10: ['course7Title', 'course7FinalPercentageMark'],
  11: ['course8Title', 'course8FinalPercentageMark'],
  12: ['course9Title', 'course9FinalPercentageMark'],
  13: ['compulsoryCreditsEarnedToDate'],
}

// Human-readable labels for every schema key
export const FIELD_LABELS = {
  semester: 'Semester', reportingPeriod: 'Reporting Period', date: 'Date',
  studentName: 'Student Name', oen: 'OEN', grade: 'Grade', homeroom: 'Homeroom',
  principal: 'Principal', studentAddress: 'Student Address', schoolCouncilChair: 'School Council Chair',
  schoolName: 'School Name', schoolTelephone: 'School Telephone',
  schoolAddress: 'School Address', schoolFax: 'School Fax',
  boardName: 'Board Name', boardEmailWebsite: 'Board Email / Website', boardAddress: 'Board Address',
  compulsoryCreditsEarnedThisReport: 'Compulsory Credits (This Report)',
  compulsoryCreditsEarnedToDate: 'Compulsory Credits (To Date)',
  englishEarnedThisReport: 'English (This Report)', englishEarnedToDate: 'English (To Date)',
  frenchEarnedThisReport: 'French (This Report)', frenchEarnedToDate: 'French (To Date)',
  mathematicsEarnedThisReport: 'Mathematics (This Report)', mathematicsEarnedToDate: 'Mathematics (To Date)',
  scienceEarnedThisReport: 'Science (This Report)', scienceEarnedToDate: 'Science (To Date)',
  canadianHistoryEarnedThisReport: 'Canadian History (This Report)', canadianHistoryEarnedToDate: 'Canadian History (To Date)',
  canadianGeographyEarnedThisReport: 'Canadian Geography (This Report)', canadianGeographyEarnedToDate: 'Canadian Geography (To Date)',
  theArtsEarnedThisReport: 'The Arts (This Report)', theArtsEarnedToDate: 'The Arts (To Date)',
  healthPhysicalEducationEarnedThisReport: 'Health & PE (This Report)', healthPhysicalEducationEarnedToDate: 'Health & PE (To Date)',
  civicsEarnedThisReport: 'Civics (This Report)', civicsEarnedToDate: 'Civics (To Date)',
  careerEarnedThisReport: 'Career Studies (This Report)', careerEarnedToDate: 'Career Studies (To Date)',
  group1EarnedThisReport: 'Group 1 Optional (This Report)', group1EarnedToDate: 'Group 1 Optional (To Date)',
  group2EarnedThisReport: 'Group 2 Optional (This Report)', group2EarnedToDate: 'Group 2 Optional (To Date)',
  group3EarnedThisReport: 'Group 3 Optional (This Report)', group3EarnedToDate: 'Group 3 Optional (To Date)',
  optionalCreditsEarnedThisReport: 'Optional Credits (This Report)', optionalCreditsEarnedToDate: 'Optional Credits (To Date)',
  totalCreditsRequiredEarnedThisReport: 'Total Credits Required (This Report)', totalCreditsRequiredEarnedToDate: 'Total Credits Required (To Date)',
  communityInvolvementEarnedThisReport: 'Community Involvement (This Report)', communityInvolvementEarnedToDate: 'Community Involvement (To Date)',
  onlineLearningRequirementEarnedThisReport: 'Online Learning (This Report)', onlineLearningRequirementEarnedToDate: 'Online Learning (To Date)',
  specialistHighSkillsMajorName: 'SHSM Name', specialistHighSkillsMajorTotalRequired: 'SHSM Total Required',
  specialistHighSkillsMajorEarnedThisReport: 'SHSM (This Report)', specialistHighSkillsMajorEarnedToDate: 'SHSM (To Date)',
  oSSLiteracyRequirementCompleted: 'OSSL Requirement Completed',
  schoolUse: 'School Use', principalSignatureDate: 'Principal Signature Date',
}

// Credit summary rows for Step 12
export const CREDIT_ROWS = [
  { label: 'Compulsory Credits',          thisReportField: 'compulsoryCreditsEarnedThisReport',         toDateField: 'compulsoryCreditsEarnedToDate',         isTotal: false },
  { label: 'English',                     thisReportField: 'englishEarnedThisReport',                   toDateField: 'englishEarnedToDate',                   isTotal: false },
  { label: 'French',                      thisReportField: 'frenchEarnedThisReport',                    toDateField: 'frenchEarnedToDate',                    isTotal: false },
  { label: 'Mathematics',                 thisReportField: 'mathematicsEarnedThisReport',               toDateField: 'mathematicsEarnedToDate',               isTotal: false },
  { label: 'Science',                     thisReportField: 'scienceEarnedThisReport',                   toDateField: 'scienceEarnedToDate',                   isTotal: false },
  { label: 'Canadian History',            thisReportField: 'canadianHistoryEarnedThisReport',           toDateField: 'canadianHistoryEarnedToDate',           isTotal: false },
  { label: 'Canadian Geography',          thisReportField: 'canadianGeographyEarnedThisReport',         toDateField: 'canadianGeographyEarnedToDate',         isTotal: false },
  { label: 'The Arts',                    thisReportField: 'theArtsEarnedThisReport',                   toDateField: 'theArtsEarnedToDate',                   isTotal: false },
  { label: 'Health & Physical Education', thisReportField: 'healthPhysicalEducationEarnedThisReport',   toDateField: 'healthPhysicalEducationEarnedToDate',   isTotal: false },
  { label: 'Civics',                      thisReportField: 'civicsEarnedThisReport',                    toDateField: 'civicsEarnedToDate',                    isTotal: false },
  { label: 'Career Studies',              thisReportField: 'careerEarnedThisReport',                    toDateField: 'careerEarnedToDate',                    isTotal: false },
  { label: 'Group 1 Optional Credits',    thisReportField: 'group1EarnedThisReport',                    toDateField: 'group1EarnedToDate',                    isTotal: false },
  { label: 'Group 2 Optional Credits',    thisReportField: 'group2EarnedThisReport',                    toDateField: 'group2EarnedToDate',                    isTotal: false },
  { label: 'Group 3 Optional Credits',    thisReportField: 'group3EarnedThisReport',                    toDateField: 'group3EarnedToDate',                    isTotal: false },
  { label: 'Optional Credits',            thisReportField: 'optionalCreditsEarnedThisReport',           toDateField: 'optionalCreditsEarnedToDate',           isTotal: false },
  { label: 'Total Credits Required',      thisReportField: 'totalCreditsRequiredEarnedThisReport',      toDateField: 'totalCreditsRequiredEarnedToDate',      isTotal: true  },
  { label: 'Community Involvement',       thisReportField: 'communityInvolvementEarnedThisReport',      toDateField: 'communityInvolvementEarnedToDate',      isTotal: false },
  { label: 'Online Learning Requirement', thisReportField: 'onlineLearningRequirementEarnedThisReport', toDateField: 'onlineLearningRequirementEarnedToDate', isTotal: false },
]
